var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 0.5H24.8C26.285 0.5 27.5 1.715 27.5 3.2V24.8C27.5 26.285 26.285 27.5 24.8 27.5H3.2C1.715 27.5 0.5 26.285 0.5 24.8V3.2C0.5 1.715 1.715 0.5 3.2 0.5ZM4.55 23.45H8.6V11.3H4.55V23.45ZM6.575 9.005C5.225 9.005 4.145 7.925 4.145 6.575C4.145 5.225 5.225 4.145 6.575 4.145C7.925 4.145 9.005 5.225 9.005 6.575C9.005 7.925 7.925 9.005 6.575 9.005ZM19.4 23.45H23.45V15.755C23.45 13.19 21.29 11.03 18.725 11.03C17.51 11.03 16.025 11.84 15.35 12.92V11.3H11.3V23.45H15.35V16.295C15.35 15.2151 16.295 14.27 17.375 14.27C18.455 14.27 19.4 15.2151 19.4 16.295V23.45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.06adb0e8aedba228b5c749adc3a5ccc4.svg";
export { ForwardRef as ReactComponent };